import * as yup from 'yup';
import docs from './attachments';
import {
  consentimentoDescontoFolha,
  cpfResponsavelLegal,
  nomeDoTutor,
  consentimentoDadosSensiveis,
  aceiteInss,
  declaracaoVeracidade,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const HerdeiroCotasSchema = yup.object({
  ...cpfResponsavelLegal,
  ...nomeDoTutor,
  ...consentimentoDescontoFolha,
  ...declaracaoVeracidade,
  ...consentimentoDadosSensiveis(),
  ...consentimentoAcertoFinanceiro,
  ...docs.HerdeiroCotasDocs.rules,
  ...aceiteInss,
});

export const HerdeiroCotasInitialValues = {
  cpfResponsavelLegal: '',
  nomeDoTutor: '',
  consentimentoDescontoFolha: false,
  consentimentoDadosSensiveis: false,
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  declaracaoVeracidade: false,
  ...docs.HerdeiroCotasDocs.initialValues,
};

export const HerdeiroCotasDocs = {
  ...docs.HerdeiroCotasDocs.docs,
};
